import { Group, Select, Stack, Text } from '@mantine/core';
import { useGetRecoveryPlans } from 'api/index';
import { i18nKeys, tKeysLoose, useTranslation } from 'locales';

import { useAutomationWizardController } from '../../controller';

import type { ActionCardProps } from './ActionCard';
import { renderFieldItem, selectedFieldStyle } from './components';

export const AssignRecoveryPlan = ({ actionIndex }: ActionCardProps) => {
  const { t } = useTranslation();
  const { form } = useAutomationWizardController();
  const { data: recoveryPlansListResponse } = useGetRecoveryPlans();

  const recoveryPlans = recoveryPlansListResponse?.data.map(plan => ({
    label: plan.attributes.name,
    value: plan.id as string,
  }));

  return (
    <Stack>
      <Text size="sm" fw={500}>
        {t(
          tKeysLoose.AUTOMATION.ACTIONS_CONFIG[
            `ASSIGN_WORKFLOW_${form.values.targetModel.toUpperCase()}`
          ],
        )}
      </Text>
      <Group gap="xl" align="end">
        <Select
          w={250}
          label={t(i18nKeys.AUTOMATION.ACTIONS_CONFIG.WORKFLOW_LABEL)}
          placeholder={t(i18nKeys.AUTOMATION.ACTIONS_CONFIG.WORKFLOW_PLACEHOLDER)}
          renderOption={renderFieldItem}
          allowDeselect={false}
          classNames={{
            option: selectedFieldStyle,
          }}
          data={recoveryPlans}
          {...form.getInputProps(`actions.${actionIndex}.assignableId`)}
        />
      </Group>
    </Stack>
  );
};
